import React, { FC, ReactNode } from 'react';
import style from './style.module.less';
import { Message, MessageType, File as MaxwellFile } from '@law-connect/types';
import {
  LawyerChatMessage,
  UserChatMessage,
} from '@law-connect/react-components';
import DownloadIcon from './download-export.svg?react';
import PencilIcon from './pencil.svg?react';
import { useAppSelector } from '../../redux/hooks';
import selectors from '../../redux/selectors';
import {} from '@galaxy-ds/core';

interface Props {
  messages: Message[];
  message: Message;
  connectionId: string;
  avatar?: ReactNode;
  avatarClassName?: string;
  wrapperClassName?: string;
  timestamp?: string | ReactNode;
  sender?: ReactNode | string;
  lawyerFirstName?: string;
  startHover: () => void;
  endHover: () => void;
}

export const ClientIntakeMessage: FC<Props> = (props) => {
  const {
    message,
    messages,
    connectionId,
    avatar,
    avatarClassName,
    wrapperClassName,
    timestamp,
    sender,
    lawyerFirstName,
    endHover,
    startHover,
  } = props;

  const allFiles = useAppSelector(selectors.file.getFiles(connectionId));
  const files = message?.fileIds?.length
    ? allFiles?.chat?.filter((f) => message.fileIds.includes(f.id))
    : null;

  if (message.type === MessageType.ClientIntakeForm) {
    if (message.from === 'lawyer') {
      const closingMessage = messages?.find(
        (m) =>
          m.type === MessageType.ClientIntakeForm &&
          m.from === 'client' &&
          m.content.id === message.content.id
      );
      const state = !closingMessage ? 'Pending' : 'Completed';

      return (
        <div className={`${style.messageWrapper} ${wrapperClassName ?? ''}`}>
          <div>
            {sender ? (
              <div
                className={`${style.senderContainer}
              ${message.from === 'lawyer' ? style.right : style.left}`}
              >
                {sender}
              </div>
            ) : null}
            <UserChatMessage
              timestamp={message.createdAt}
              className={style.message}
              onMouseEnter={startHover}
              onMouseLeave={endHover}
            >
              <div className={style.iconContainer}>
                <PencilIcon className={style.icon} />
              </div>
              { lawyerFirstName ? 
                (<>
                  {lawyerFirstName} has sent you an intake form.
                </>) : (<>
                  You have sent the client an intake form.
                  <b> {state}</b>.
                </>)}
            </UserChatMessage>
            {timestamp ? (
              <div className={`${style.timestampContainer}`}>
                {timestamp}
              </div>
            ) : null}
          </div>
          <div className={`${avatarClassName ?? ''}`}>
            {avatar}
          </div>
        </div>
      );
    } else {
      // is from client
      return (
        <div className={`${style.messageWrapper} ${wrapperClassName ?? ''}`}>
          <div className={`${avatarClassName ?? ''}`}>
            {avatar}
          </div>
          <div>
            {sender ? (
              <div
                className={`${style.senderContainer} ${style.left}`}
              >
                {sender}
              </div>
            ) : null}
            <LawyerChatMessage
              timestamp={message.createdAt}
              className={`${style.message} ${style.sender}`}
              onMouseEnter={startHover}
              onMouseLeave={endHover}
            >
              <div className={style.lawyerIconContainer}>
                <DownloadIcon className={style.icon} />
              </div>
              User has completed intake form.
              {files?.length && files[0]?.url?.path ? (
                <>
                  &nbsp;
                  <span className={style.link} onClick={() => {
                    document.location.href = files[0].url.path ?? '';
                  }}>
                    Download
                  </span>
                  .
                </>
              ) : null}
            </LawyerChatMessage>
            {timestamp ? (
              <div className={`${style.timestampContainer}`}>
                {timestamp}
              </div>
            ) : null}
          </div>
        </div>
      );
    }
  }
};
